import type { HTMLAttributes, JSX } from 'react'
import { cn } from '#src/cn.ts'

export function TypographySubtle({
  className,
  ...delegated
}: HTMLAttributes<HTMLParagraphElement>): JSX.Element {
  return <p className={cn('text-sm', className)} {...delegated} />
}
